import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";
import "../Body/Body.css";

export default function Body({ bannerData, timerData, formData, links }) {
  const imgCDNURL = process.env.REACT_APP_APSECOND;

  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col sm={12} md={12} xl={7} lg={7}>
              <div className="bannertextstag">
                <h1>
                Masterminds
                </h1>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="weeeklytext">
          <div>
            <p>
              Your Weekly Digest of <br></br> Mortgage Insights
            </p>
          </div>
          <div className="desktopmcale">
            <img
              src={imgCDNURL + "aprilcalender.webp"}
              className="aprilcalender"
              loading="lazy"
            />
          </div>
        </div>
        <div className="mobilecalnder">
          <img
            src={imgCDNURL + "aprilcalender.webp"}
            className="aprilcalendermbile"
            loading="lazy"
          />
        </div>
        <div className="aheadofcurve">
          <Container>
            <Row>
              <Col sm={12} md={12} xl={4} lg={4}>
                <p>
                  <img
                    src={imgCDNURL + "morganlogo.png"}
                    className="morganscreenlogo"
                    loading="lazy"
                  />
                </p>

                <p className="moragntext2">
                  <a
                    href={links.mobileAppURL}
                    target="_blanck"
                    rel="noreferrer"
                  >
                    {links.mobileAppName}
                  </a>{" "}
                </p>
              </Col>
              <Col sm={12} md={12} xl={8} lg={8}>
                <p className="stayingtext">
                  Staying Informed, Ahead of the Curve
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
